// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-radix-popper-content-wrapper]{z-index:9999 !important}", "",{"version":3,"sources":["webpack://src/components/registration/v2/PostRegEditDrawer/Edit/ParticipantInfo.scss"],"names":[],"mappings":"AAAA,oCAEI,uBAAA","sourcesContent":["[data-radix-popper-content-wrapper] {\n    // posotion the popover above the drawer\n    z-index: 9999 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
